/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/react';
import classNames from 'classnames';
import rightFilled from 'jimu-icons/svg/filled/directional/right.svg';
import downFilled from 'jimu-icons/svg/filled/directional/down.svg';
import { loadArcGISJSAPIModules } from '../../arcgis-js-api-module-loader';
import { useEffectOnce, useTranslation } from '../../hooks';
export var LoadStatus;
(function (LoadStatus) {
    LoadStatus["Pending"] = "Pending";
    LoadStatus["Fulfilled"] = "Fulfilled";
    LoadStatus["Rejected"] = "Rejected";
})(LoadStatus || (LoadStatus = {}));
const style = css `
  border: none;
  .jimu-btn.expanded {
    align-self: flex-start;
  }
  .esri-feature.esri-widget {
    background-color: transparent;
  }
  .esri-feature__title {
    font-size: 14px;
    height: 16px;
    font-weight: 500;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .esri-feature__content-element {
    padding: 0;
    margin-bottom: 0;
    margin-top: var(--sys-spacing-1);
  }
  .esri-feature__loading-container {
    display: none;
  }
  .feature-info-widget {
    max-width: calc(100% - 20px);
  }
`;
export default function FeatureInfo(props) {
    const { graphic, popupTemplate, uiComponents } = props;
    const [showContent, setShowContent] = React.useState(false);
    const featureRef = React.useRef(null);
    const featureContainerRef = React.useRef(null);
    useEffectOnce(() => {
        loadArcGISJSAPIModules([
            'esri/widgets/Feature'
        ]).then(modules => {
            var _a;
            const [Feature] = modules;
            const container = document && document.createElement('div');
            container.className = 'jimu-widget';
            (_a = featureContainerRef.current) === null || _a === void 0 ? void 0 : _a.appendChild(container);
            const feature = featureRef.current;
            feature && !feature.destroyed && feature.destroy();
            graphic.popupTemplate = popupTemplate;
            featureRef.current = new Feature({
                container: container,
                defaultPopupTemplateEnabled: true,
                graphic,
                visibleElements: {
                    title: true,
                    content: {
                        fields: false
                    },
                    lastEditedInfo: false
                }
            });
        });
    });
    React.useEffect(() => {
        featureRef.current && (featureRef.current.visibleElements = {
            title: true,
            content: {
                fields: showContent
            },
            lastEditedInfo: false
        });
    }, [showContent]);
    const toggleExpanded = React.useCallback((e) => {
        e.stopPropagation();
        setShowContent(oldValue => !oldValue);
    }, []);
    const { Button, jimuUIMessages, Icon } = uiComponents;
    const translate = useTranslation(jimuUIMessages);
    return (jsx("div", { className: 'feature-info-component d-flex align-items-center p-2', css: style },
        jsx(Button, { "aria-label": translate(showContent ? 'collapse' : 'expand'), className: classNames('p-0 jimu-outline-inside', { expanded: showContent }), type: 'tertiary', icon: true, size: 'sm', onClick: toggleExpanded }, showContent ? jsx(Icon, { icon: downFilled, size: 's' }) : jsx(Icon, { icon: rightFilled, size: 's', autoFlip: true })),
        jsx("div", { className: 'feature-info-widget flex-grow-1', ref: featureContainerRef })));
}
